import {
  Hydrate,
  QueryClient as ReactQueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React, { useState } from 'react';

type QueryClientProps = {
  children: React.ReactNode;
  dehydratedState?: unknown;
};

export const FIVE_MINUTES = 300000;

let appQueryClient: ReactQueryClient | undefined;

export function getAppQueryClient() {
  return appQueryClient;
}

export function QueryClient({ children, dehydratedState }: QueryClientProps) {
  const [client] = useState(() => {
    const queryClient = new ReactQueryClient({
      defaultOptions: {
        queries: {
          staleTime: FIVE_MINUTES,
          retry: false,
          refetchOnWindowFocus: false,
        },
      },
    });
    if (typeof window !== 'undefined') {
      appQueryClient = queryClient;
    }
    return queryClient;
  });

  return (
    <QueryClientProvider client={client}>
      <Hydrate state={dehydratedState}>
        {children}
        <ReactQueryDevtools />
      </Hydrate>
    </QueryClientProvider>
  );
}
